import { waLink, BUSINESS_WA } from "@/lib/api";
import { MessageCircle } from "lucide-react";

export default function WhatsAppFab() {
  // Fallback: hardcode only if env truly missing (shouldn't happen in prod)
  const href = BUSINESS_WA ? waLink() : "https://wa.me/919082542692?text=Hi%20Tech%20Detailers";
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-2 bg-[#25D366] text-black font-semibold px-4 py-3 rounded-full shadow-lg hover:brightness-110 transition"
    >
      <MessageCircle className="h-5 w-5" />
      <span className="hidden sm:inline text-sm">Chat on WhatsApp</span>
    </a>
  );
}
